import React from 'react';
import Collapse from '@material-ui/core/Collapse';
import { createStyles, makeStyles, Theme, withStyles /*fade*/ } from '@material-ui/core/styles';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
// import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import { TransitionProps } from '@material-ui/core/transitions';
import TreeItem, { TreeItemProps } from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import { ArrowDropDown, ArrowRight } from '@material-ui/icons';

// function MinusSquare(props: SvgIconProps): JSX.Element {
//     return (
//         <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
//             {/* tslint:disable-next-line: max-line-length */}
//             <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
//         </SvgIcon>
//     );
// }

// function PlusSquare(props: SvgIconProps): JSX.Element {
//     return (
//         <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
//             {/* tslint:disable-next-line: max-line-length */}
//             <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
//         </SvgIcon>
//     );
// }

// function CloseSquare(props: SvgIconProps): JSX.Element {
//     return (
//         <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
//             {/* tslint:disable-next-line: max-line-length */}
//             <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
//         </SvgIcon>
//     );
// }

function TransitionComponent(props: TransitionProps): JSX.Element {
    // const style = useSpring({
    //     from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    //     to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
    // });

    return (
        // <animated.div style={style}>
        <Collapse {...props} />
        // </animated.div>
    );
}

const StyledTreeItem = withStyles((theme: Theme) =>
    createStyles({
        iconContainer: {
            '& .close': {
                opacity: 0.3,
            },
        },
        group: {
            marginLeft: 7,
            paddingLeft: 18,
            // borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
        },
    }),
)((props: TreeItemProps) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootCustomTree: {
            flexGrow: 1,
            '& .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label': {
                backgroundColor: 'transparent',
            },
            '& .MuiTreeItem-content:hover .MuiTreeItem-label:hover': {
                backgroundColor: 'transparent',
            },
        },
        item: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.colors.table.hover,
                borderTop: `1px solid ${theme.palette.colors.table.separator}`,
                borderBottom: `1px solid ${theme.palette.colors.table.separator}`,
            },
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.colors.table.highlighted,
                borderTop: `1px solid ${theme.palette.colors.table.separator}`,
                borderBottom: `1px solid ${theme.palette.colors.table.separator}`,
            },
        },
    }),
);

interface CustomTreeProps {
    datas: any[];
    onClick?: Function;
    onDoubleClick?: Function;
    expandId?: string;
    expandedIds?: string[];
    /**
     * Bump this to reapply `expandedIds` even when they did not change, the tree being
     * uncontrolled once mounted. Needed to fold back branches the user opened by hand.
     */
    expansionKey?: string | number;
    customRow: (row) => JSX.Element;
}

export default function CustomizedTreeView(props: CustomTreeProps): JSX.Element {
    const classes = useStyles();

    const { datas, onClick, onDoubleClick, expandId, expandedIds, expansionKey, customRow } = props;

    const defaultExpanded = [...(expandedIds ?? [])];
    expandForKey(datas, expandId);

    function expandForKey(tree, key) {
        for (let i = 0; i < tree.length; i++) {
            const sub = tree[i];
            if (sub.id === key) {
                defaultExpanded.push(sub.id);
                return true;
            } else {
                if (sub.children?.length > 0) {
                    const found = expandForKey(sub.children, key);
                    if (found) {
                        defaultExpanded.push(sub.id);
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function getBranches(nodes) {
        return nodes.map((node) => {
            const { id, children } = node;
            return (
                <StyledTreeItem
                    key={id}
                    nodeId={id}
                    className={classes.item}
                    onDoubleClick={onDoubleClick ? onDoubleClick(node) : null}
                    onClick={onClick ? onClick(node) : null}
                    label={customRow(node)}
                >
                    {getBranches(children)}
                </StyledTreeItem>
            );
        });
    }

    return (
        <TreeView
            key={`${expansionKey ?? ''}|${defaultExpanded.join(',')}`}
            className={classes.rootCustomTree}
            defaultExpanded={defaultExpanded}
            defaultCollapseIcon={<ArrowDropDown style={{ fontSize: '2em' }} />}
            defaultExpandIcon={<ArrowRight style={{ fontSize: '2em' }} />}
            defaultEndIcon={null}
        >
            {getBranches(datas)}
        </TreeView>
    );
}
